<template>
  <div>
    <template v-if="model.type=== 'boolean'">
                <BoxItem
                    :title="$t('ATTRIBUTE-LABEL-DEFAULT-VALUE')"
                    :value="model.defaultValue"
                    :items="defaultBooleanOptions"
                    itemsValue="value"
                    itemsText="label"
                    @updateValue="model.defaultValue = $event"
                  />  
    </template>
    <template v-else-if="model.type === 'enum'">
      <BoxItem
        v-if="showEnumOptions"
                    :title="$t('ATTRIBUTE-LABEL-DEFAULT-VALUE')"
                    :value="model.defaultValue"
                    :items="validEnumOptions"
                    @updateValue="model.defaultValue = $event"
                  />  
    </template>
    <template v-else-if="model.type === 'number'">
      <BoxItem
                    type="number"
                    :hasError="invalidField"
                    :error-message="invalidMessage"
                    :title="$t('ATTRIBUTE-LABEL-DEFAULT-VALUE')"
                    :value="model.defaultValue"
                    @updateValue="model.defaultValue = $event"
                  />
    </template>
    <template v-else-if="model.type === 'date'">
      <BoxItem
                    type="date"
                    :title="$t('ATTRIBUTE-LABEL-DEFAULT-VALUE')"
                    :value="model.defaultValue"
                    @updateValue="model.defaultValue = $event"
                  />
    </template>
              <BoxItem
                    v-else
                    :hasError="invalidField"
                    :error-message="invalidMessage"
                    :title="$t('ATTRIBUTE-LABEL-DEFAULT-VALUE')"
                    :value="model.defaultValue"
                    @updateValue="model.defaultValue = $event"
                  />
  </div>
</template>

<script>
import Box from "../../../components/ui-elements/Box.vue";
import BoxItem from '../../../components/ui-elements/BoxItem.vue';
import SubHeader from "../../../components/ui-elements/SubHeader.vue";
import {cloneDeep} from 'lodash';

  export default {
    name: 'AttributeDefaultValue',
    props:{
      item: {
        type: Object,
        required: true
      },
      constraints: {
        type: Object,
        required: true
      },
      enumOptions: {
        type: Array
      }
    },
    data(){
      return {
        model: {
          name: null,
          unit: null,
          type: null,
          displayName: {},
          isHostAttribute: false,
          syncWithKiSoft: false,
          isWritable: false, 
        },
        invalidField: false,
        invalidMessage: ''
      }
    },
    components: {
      Box, BoxItem, SubHeader
    },
    watch:{
      item: {
        handler(){
          this.model = cloneDeep(this.item);
        },
        deep: true,
        immediate: true
      },
      constraints: {
        handler(){
          this.validateField();
        },
        deep: true,
        immediate: true
      },
      'model.defaultValue': {
        handler(newValue, oldValue){
          if(this.model.defaultValue !== this.item.defaultValue){
            this.$emit('updateDefaultValue', this.model.defaultValue);
            this.validateField();
          }
        },
        deep: true
      },
      enumOptions: {
        handler(){
          if(this.model.defaultValue){
            const hasElement = this.enumOptions.find(el => el === this.model.defaultValue);
            if(!hasElement){
              this.model.defaultValue = null;
            }
          }
        },
        deep: true
      },
      invalidField:{
        handler(){
          this.$emit('invalidField', this.invalidField);
        }
      }
     
    },
    computed: {
      defaultBooleanOptions(){
        return [
        {value: 1, label: this.$i18n.t('GLOBAL_TRUE')},
        {value: 0, label: this.$i18n.t('GLOBAL_FALSE')},
        ];
      },
      validEnumOptions(){
        return this.enumOptions.filter((el) => el.length > 0);
      },
      showEnumOptions(){
        return this.enumOptions.some((el) => el.length > 0);
      },
      isStringType(){
        return this.model.type === 'string';
      }
    },
    created(){

    },
    methods:{
      validateField(){
        if(this.model.defaultValue === undefined || this.model.defaultValue === null) return;
        if(this.constraints.min !== undefined && this.constraints.min !== null){
          if(this.isStringType){
              if(this.model.defaultValue.length < this.constraints.min){
                this.invalidField = true;
                this.invalidMessage = this.$i18n.t('ATTRIBUTE-DEFAULT-VALUE-INVALID-CREDENTIAL-MIN');
                return;    
              }else{
                this.invalidField = undefined;
                this.invalidMessage = '';
              }
          }else{
            if(Number(this.constraints.min) > Number(this.model.defaultValue)){
              this.invalidField = true;
              this.invalidMessage = this.$i18n.t('ATTRIBUTE-DEFAULT-VALUE-INVALID-CREDENTIAL-MIN');
              return;
            }else{
              this.invalidField = undefined;
              this.invalidMessage = '';
            }
          }
          
        }        
        if(this.constraints.max !== undefined && this.constraints.max !== null){
          if(this.isStringType){
              if(this.model.defaultValue.length > this.constraints.max){
                this.invalidField = true;
                this.invalidMessage = this.$i18n.t('ATTRIBUTE-DEFAULT-VALUE-INVALID-CREDENTIAL-MAX');
                return;    
              }else{
                this.invalidField = undefined;
                this.invalidMessage = '';
              }
          }else{
            if(Number(this.constraints.max) < Number(this.model.defaultValue)){
              this.invalidField = true;
              this.invalidMessage = this.$i18n.t('ATTRIBUTE-DEFAULT-VALUE-INVALID-CREDENTIAL-MAX');
              return;
            }else{
              this.invalidField = undefined;
              this.invalidMessage = '';
            }
          }
        }        

        if(this.constraints.pattern !== undefined && this.constraints.pattern !== null){
          const regularExprCheck = new RegExp(this.constraints.pattern);
          if(!regularExprCheck.test(this.model.defaultValue)){
            // invalid value
            this.invalidField = true;
            this.invalidMessage = this.$i18n.t('ATTRIBUTE-DEFAULT-VALUE-INVALID-CREDENTIAL-PATTERN');
            return;
          }else{
            this.invalidField = undefined;
            this.invalidMessage = '';
          
          }
          
        }        
      }

    }
  }
</script>

<style lang="scss" scoped>

</style>
